import {OurApi} from './OurApi';
export default OurApi;
